import { FC } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import useClassNames from 'helpers/hooks/useClassNames';
import ContentCard from './content-card';
import { ContentSliderProps, ContentSliderColumn } from './types';
import Wrapper from '../../../HOC/wrapper';
import Subtitle from '../../atoms/subtitle';

const tabletGridClasses: Record<ContentSliderColumn, string> = {
  one: 'md:grid-cols-1',
  two: 'md:grid-cols-2',
  three: 'md:grid-cols-3',
};

const desktopGridClasses: Record<ContentSliderColumn, string> = {
  one: 'lg:grid-cols-1',
  two: 'lg:grid-cols-2',
  three: 'lg:grid-cols-3',
};

const ContentSlider: FC<ContentSliderProps> = ({
  title,
  subtitle,
  slides,
  columnsTablet = 'two',
  columnsDesktop = 'three',
}) => {
  const safeColumnsTablet = tabletGridClasses[columnsTablet as ContentSliderColumn]
    ? (columnsTablet as ContentSliderColumn)
    : ('two' as ContentSliderColumn);

  const safeColumnsDesktop = desktopGridClasses[columnsDesktop as ContentSliderColumn]
    ? (columnsDesktop as ContentSliderColumn)
    : ('three' as ContentSliderColumn);

  const gridClasses = useClassNames([
    'grid',
    'gap-24',
    'grid-cols-1',
    tabletGridClasses[safeColumnsTablet],
    desktopGridClasses[safeColumnsDesktop],
    'container',
  ]);

  return (
    <Wrapper clearDefaultStyles className="py-32 lg:py-64">
      <div className="container mb-32 flex flex-col gap-16">
        {title && (
          <Typography className="body-text-2xlarge font-medium" as="h2">
            {title}
          </Typography>
        )}
        {subtitle && <Subtitle className="body-text-large" subtitle={subtitle} />}
      </div>

      <div className={gridClasses}>
        {slides.map((slide, index) => (
          <ContentCard key={`${slide.title}-${index}`} {...slide} />
        ))}
      </div>
    </Wrapper>
  );
};

export default ContentSlider;
